import * as React from 'react';
import { translation } from '../../i18n';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { logout } from '../../security/keycloak';
import MyAppBar from '../../navigation/MyAppBar';
import { observable } from 'mobx';

type LocalStyles = 'root' | 'button';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    margin: theme.spacing.unit,
    textAlign: 'center',
    padding: theme.spacing.unit * 2
  },
  button: {
    marginTop: theme.spacing.unit * 4,
  },
});

type PropsWithStyle = WithStyles<LocalStyles>;

class UnknownUserPage extends React.Component<PropsWithStyle> {

  constructor(props: Readonly<PropsWithStyle>) {
    super(props);
  }

  public render() {
    return (
      <>
        <MyAppBar showSearch={false} searchText={observable.box('')}/>
        <Paper elevation={1} className={this.props.classes.root}>
          <div>
            <Typography variant="h4">
              {translation.t('errors.unknownUser.headline')}
            </Typography>
            <br/>
            <Typography variant="body1">
              {translation.t('errors.unknownUser.body')}
            </Typography>

            <Button
              className={this.props.classes.button}
              variant="contained"
              color="primary"
              onClick={() => logout()}>
              {translation.t('menu.logout')}
            </Button>
          </div>
        </Paper>
        </>
    );
  }

}

export default withStyles(localStyles)(UnknownUserPage);
